import React from 'react';
import './AgenticAiPage.css';

const AgenticAiPage = ({ onContactClick }) => {
  const features = [
    {
      icon: "⎈",
      title: "End-to-end workflow automation",
      desc: "From trigger to completion - AI agents orchestrate multi-step processes without manual intervention."
    },
    {
      icon: "→",
      title: "Multi-step decision making",
      desc: "Agents evaluate conditions, branch logic, and take action based on context and rules."
    },
    {
      icon: "⍦",
      title: "API integrations & data sync",
      desc: "Connect to your tools and systems. Sync data, trigger actions, and keep everything in harmony."
    },
    {
      icon: "⟳",
      title: "Error handling & retries",
      desc: "Automatic retries, fallbacks, and alerts when something fails - built for reliability."
    },
    {
      icon: "⚙",
      title: "Custom logic & rules",
      desc: "Define your business rules. Agents execute exactly how you want, every time."
    },
    {
      icon: "📊",
      title: "Performance monitoring",
      desc: "Track runs, success rates, and latency. Know what's working and where to optimize."
    },
    {
      icon: "▤",
      title: "Data processing pipelines",
      desc: "Transform, validate, and move data between systems at scale."
    },
    {
      icon: "👥",
      title: "Customer onboarding flows",
      desc: "Automate welcome sequences, setup tasks, and first-time user journeys."
    },
    {
      icon: "📄",
      title: "Report generation",
      desc: "Generate and distribute reports on schedule - no manual export needed."
    }
  ];

  return (
    <div className="agentic-ai-page">
      {/* Hero Section */}
      <section className="agentic-hero">
        <div className="agentic-hero-content">
          <h1 className="agentic-hero-title">Agentic AI<br/>Automations</h1>
          <p className="agentic-hero-subtitle">AUTOMATE REPETITIVE WORKFLOWS END-TO-END.</p>
          <p className="agentic-hero-desc">
            Autonomous AI agents that handle complex workflows, data processing, and business operations end-to-end.
          </p>
          
          <div className="agentic-hero-stats">
            <div className="agentic-stat-item">
              <h3>80%</h3>
              <p>Time Saved On Manual Tasks</p>
              <div className="stat-progress-bar"><div className="stat-progress" style={{width: '80%'}}></div></div>
            </div>
            <div className="agentic-stat-item">
              <h3>99.9%</h3>
              <p>Automation Reliability</p>
              <div className="stat-progress-bar"><div className="stat-progress" style={{width: '99.9%'}}></div></div>
            </div>
            <div className="agentic-stat-item">
              <h3>24/7</h3>
              <p>Continuous Operation</p>
              <div className="stat-progress-bar"><div className="stat-progress" style={{width: '100%'}}></div></div>
            </div>
          </div>
          
          <div className="agentic-hero-cta">
            <button className="agentic-btn-primary" onClick={onContactClick}>Book a Call</button>
            <button className="agentic-btn-secondary">
              <span className="play-icon">▶</span> Watch a Demo
            </button>
          </div>
        </div>
        
        <div className="agentic-hero-visual">
          <div className="agentic-glowing-ring">⚡</div>
        </div>
      </section>

      {/* Features Section */}
      <section className="agentic-features-section">
        <h2 className="agentic-section-title">Key Features</h2>
        
        <div className="agentic-features-grid">
          {features.map((feat, index) => (
            <div key={index} className="agentic-feature-card">
              <div className="feature-icon">{feat.icon}</div>
              <h3 className="feature-title">{feat.title}</h3>
              <p className="feature-desc">{feat.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="agentic-cta-section">
        <div className="agentic-cta-content">
          <p>Book a call. We'll walk through your setup and show you how automations can streamline your operations.</p>
          <button className="agentic-btn-cta" onClick={onContactClick}>Book a Call</button>
        </div>
      </section>
    </div>
  );
};

export default AgenticAiPage;
